import type { SampleOrderLinkFragmentFragment } from '@packages/gql/generated/shopping/graphql';

export const getSampleOrderGlycerinDetail = (
  sampleOrderType: SampleOrderLinkFragmentFragment['sampleOrderType'],
) => {
  switch (sampleOrderType) {
    case 'WOOD':
      return 'Holzmuster';
    case 'UPHOLSTERY':
      return 'Stoffmuster';
    default:
      return undefined;
  }
};
